import { React, useState, useEffect, useContext, useMemo } from "react";

import {
  Dialog,
  DialogContent,
  AppBar,
  IconButton,
  Typography,
  Toolbar,
  Grid,
  Slide,
  Container,
} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";

import Btn from "../../../../components/buttons/Btn";

import { DialogProduto, Body, Margin } from "../styles/Emissao";
import Tabs from "../../../../components/tabs/TabsErp";
import TabEmissaoICMS from "./TabEmissaoICMS";
import TabEmissaoIPI from "./TabEmissaoIPI";
import TabEmissaoPIS from "./TabEmissaoPIS";
import TabEmissaoCofins from "./TabEmissaoCofins";
import TabEmissaoB2B from "./TabEmissaoB2B";
import TabEmissaoDadosProduto from "./TabEmissaoDadosProduto";
import TabEmissaoII from "./TabEmissaoII";
import TabEmissaoCombustivel from "./TabEmissaoCombustivel";

import useEmissaoController from "../controllers/EmissaoController";
import { ParametrosProdutoContext } from "../contexts/ParametrosProdutoContext";
import { EmissaoContext } from "../contexts/EmissaoContext";
import useCalculosTributacao from "../controllers/RulesEmissaoCalculosTributacao";
import { GlobalVariables } from "../../../../GlobalVariables";
import TabEmissaoIPIDevolvido from "./TabEmissaoIPIDevolvido";
import TabEmissaoExportacaoItem from "./TabEmissaoExportacaoItem";

const ModalEmissaoParamProduto = ({
  setModalProdutosOpen,
  modalProdutosOpen,
  index,
}) => {
  const { handleAddProduct, handleEditItemProduct, clearProductItem } =
    useEmissaoController();

  const {
    handleCalcBCIcms,
    handleCalcBcIcmsSt,
    handleCalcIcms,
    handleCalcIcmsSt,
    handleFcpIcms,
    handleFcpIcmsSt,
    handleCreditIcms,
    handleFcpIcmsDi,
  } = useCalculosTributacao();

  const { productError, productDataCfop } = useContext(
    ParametrosProdutoContext
  );

  const {
    headerOperation,
    visualizationOnly,
    nfeMontageSubtype,
    listCfopFuel,
    saveBlocked,
    headerTypeNfe,
    headerFinnally,
    headerModel,
  } = useContext(EmissaoContext);

  const [tabIndex, setTabIndex] = useState(0);
  const [tabHeaders, setTabHeaders] = useState([]);
  const [tabContents, setTabContents] = useState([]);

  const handleClose = () => {
    clearProductItem();
    setModalProdutosOpen(false);
  };

  useEffect(() => {
    if (index !== null) {
      handleEditItemProduct(index);
    }
    // eslint-disable-next-line
  }, [index]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleCalcIcmsSt();
  }, [handleCalcIcmsSt, nfeMontageSubtype]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleCalcIcms();
  }, [handleCalcIcms, nfeMontageSubtype]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleCalcBcIcmsSt();
  }, [handleCalcBcIcmsSt, nfeMontageSubtype]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleCalcBCIcms();
  }, [handleCalcBCIcms, nfeMontageSubtype]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") {
      handleFcpIcmsDi();
      return;
    }
    handleFcpIcms();
  }, [handleFcpIcms, handleFcpIcmsDi, nfeMontageSubtype]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleFcpIcmsSt();
  }, [handleFcpIcmsSt, nfeMontageSubtype]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleCreditIcms();
  }, [handleCreditIcms, nfeMontageSubtype]);

  useEffect(() => {
    const displayReturnedIpiTab =
      headerFinnally?.value === GlobalVariables.nfe.purpose.returnOfMerchandise;

    const displayImportTab =
      headerOperation?.value === GlobalVariables.nfe.operations.foreign &&
      headerTypeNfe?.value === GlobalVariables.nfe.types.entry;

    const displayExportTab =
      headerOperation?.value === GlobalVariables.nfe.operations.foreign &&
      headerTypeNfe?.value === GlobalVariables.nfe.types.exit;

    const displayFuelTab = listCfopFuel.find(
      (e) => e.label === productDataCfop?.cfop?.substr(-3)
    );

    const displayB2bTab =
      headerModel?.value !== GlobalVariables.nfe.models.NFCe;

    const displayIpiTab =
      headerModel?.value !== GlobalVariables.nfe.models.NFCe;

    const hasError = (tabName) =>
      !!(productError?.tabs || []).find((value) => value === tabName);

    setTabHeaders([
      { label: "Dados do Produto" },
      {
        label: "ICMS",
        error: hasError("icms"),
      },
      ...(displayIpiTab
        ? [
            {
              label: "IPI",
              error: hasError("ipi"),
            },
          ]
        : []),
      ...(displayReturnedIpiTab
        ? [
            {
              label: "IPI DEVOLVIDO",
              error: hasError("ipiDevolvido"),
            },
          ]
        : []),
      {
        label: "PIS",
        error: hasError("pis"),
      },
      {
        label: "COFINS",
        error: hasError("cofins"),
      },
      ...(displayImportTab ? [{ label: "II" }] : []),
      ...(displayB2bTab
        ? [
            {
              label: "B2B",
            },
          ]
        : []),
      ...(displayFuelTab ? [{ label: "Combustível" }] : []),
      ...(displayExportTab
        ? [{ label: "Exportação", error: hasError("exportacao") }]
        : []),
    ]);

    setTabContents(
      [
        <TabEmissaoDadosProduto key="tab-emissao-dados-produto" />,
        <TabEmissaoICMS key="tab-emissao-icms" />,
        ...[displayIpiTab && <TabEmissaoIPI key="tab-emissao-ipi" />],
        ...[
          displayReturnedIpiTab && (
            <TabEmissaoIPIDevolvido key="tab-emissao-ipi-devolvido" />
          ),
        ],
        <TabEmissaoPIS key="tab-emissao-pis" />,
        <TabEmissaoCofins key="tab-emissao-cofins" />,
        ...[displayImportTab && <TabEmissaoII key="tab-emissao-ii" />],
        ...[displayB2bTab && <TabEmissaoB2B key="tab-emissao-b2b" />],
        ...[
          displayFuelTab && (
            <TabEmissaoCombustivel key="tab-emissao-combustivel" />
          ),
        ],
        ...[
          displayExportTab && (
            <TabEmissaoExportacaoItem key="tab-emissao-exportacao" />
          ),
        ],
      ].filter((e) => e)
    );
  }, [
    headerFinnally?.value,
    headerOperation?.value,
    headerTypeNfe?.value,
    listCfopFuel,
    productDataCfop?.cfop,
    productError?.tabs,
    headerModel?.value,
  ]);

  return (
    <>
      <Dialog
        fullScreen
        open={modalProdutosOpen}
        onClose={handleClose}
        aria-labelledby="dialog-title"
      >
        <Slide direction="up" in={modalProdutosOpen} mountOnEnter unmountOnExit>
          <DialogProduto>
            <AppBar>
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={handleClose}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
                <Grid item lg={12}>
                  <Typography variant="h6">PARÂMETROS DE PRODUTO</Typography>
                </Grid>
              </Toolbar>
            </AppBar>
            <DialogContent>
              <Body>
                <Container maxWidth="xl">
                  <Tabs
                    headers={tabHeaders}
                    children={tabContents}
                    tabIndex={tabIndex}
                    onChange={(event, value) => {
                      if (Number.isInteger(value)) setTabIndex(value);
                    }}
                  />
                  <Margin top="15" bottom="10">
                    <Grid container spacing={3}>
                      <Grid item sm></Grid>
                      {!visualizationOnly && !saveBlocked && (
                        <Grid item>
                          <Btn
                            label="incluir"
                            onClick={() =>
                              handleAddProduct(setModalProdutosOpen, index)
                            }
                          />
                        </Grid>
                      )}
                      <Grid item>
                        <Btn
                          label={!visualizationOnly ? "Cancelar" : "Voltar"}
                          bgcolor="tertiary"
                          onClick={handleClose}
                        />
                      </Grid>
                    </Grid>
                  </Margin>
                </Container>
              </Body>
            </DialogContent>
          </DialogProduto>
        </Slide>
      </Dialog>
    </>
  );
};

export default ModalEmissaoParamProduto;
